<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 6.44444V4.22222C2 3.63285 2.23413 3.06762 2.65087 2.65087C3.06762 2.23413 3.63285 2 4.22222 2H6.44444M17.5556 2H19.7778C20.3671 2 20.9324 2.23413 21.3491 2.65087C21.7659 3.06762 22 3.63285 22 4.22222V6.44444M22 17.5556V19.7778C22 20.3671 21.7659 20.9324 21.3491 21.3491C20.9324 21.7659 20.3671 22 19.7778 22H17.5556M6.44444 22H4.22222C3.63285 22 3.06762 21.7659 2.65087 21.3491C2.23413 20.9324 2 20.3671 2 19.7778V17.5556"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16.4453 7.55469H7.55642C6.94277 7.55469 6.44531 8.05215 6.44531 8.6658V15.3325C6.44531 15.9461 6.94277 16.4436 7.55642 16.4436H16.4453C17.059 16.4436 17.5564 15.9461 17.5564 15.3325V8.6658C17.5564 8.05215 17.059 7.55469 16.4453 7.55469Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
